import { useState } from 'react';
import Cropper from 'react-easy-crop';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton';

import getCroppedImgData from '../functions/cropImage';

import './styles/ImageCropper.css';

const ImageCropper = ({ source, 
  width, 
  height, 
  cropShape, 
  aspect = null, 
  setCroppedFile, 
  exitCrop,
  setCroppedUrl = () => {}, 
  continueCrop = () => {}, 
  isLoading }) => {
  const [zoom, setZoom] = useState(1);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Use the aspect prop if provided; otherwise, fallback to dynamic width/height aspect ratio
  const aspectRatio = aspect || (width / height);

  const onCropChange = (newCrop) => {
    setCrop(newCrop);
  };

  const onZoomChange = (newZoom) => {
    setZoom(newZoom);
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onCrop = async () => {
    try {
      const blobFile = await getCroppedImgData(source, croppedAreaPixels);
      const file = new File([blobFile], 'croppedImage.png', { type: 'image/png' });
  
      if (setCroppedFile && typeof setCroppedFile === "function") {
        setCroppedFile(file);
      } else {
        console.error("setCroppedFile is not a function");
      }
  
      if (setCroppedUrl && typeof setCroppedUrl === "function") {
        const fileUrl = URL.createObjectURL(file);
        setCroppedUrl(fileUrl);
      } else {
        console.error("setCroppedUrl is not a function");
      }
    } catch (e) {
      console.error("Error during cropping in ImageCropper:", e);
    }
  };
  
  const handleWheel = (e) => {
    const direction = e.deltaY > 0 ? -0.1 : 0.1;
    const newZoom = zoom + direction;
    setZoom(newZoom > 1 ? newZoom : 1);
  };
  
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';

  return (
    <>
      <div onWheel={handleWheel} className={`w-100 container-wheel-cropper ${cropAreaClass}`} >
        <Cropper
          image={source}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          cropShape={cropShape}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          showGrid={true}
          onCropComplete={onCropComplete}
        />
      </div>
      <div className="artwork-options__download-template-templates-crop-options">
        <div className="artwork-options__footer-background">
          <p onClick={exitCrop}>Exit</p>
          <ContinueButton 
            loading={isLoading}
            className="choose-action"
            continueClass={false}
            onClick={() => { onCrop(); continueCrop(); }}
          >
                        Choose
          </ContinueButton>
        </div>
      </div>
    </>
  );
};

export default ImageCropper;
